import { createContext, useContext } from 'react';
import { DEFAULT_PRICE } from '../constants';
var noop = function noop() {};
export var ProductContext = /*#__PURE__*/createContext({
  value: {},
  onChange: noop,
  price: DEFAULT_PRICE,
  priceList: {}
});
export var useProductContext = function useProductContext() {
  return useContext(ProductContext);
};